import React, { useContext } from "react";
import millify from "millify";
import {
  Typography,
  Row,
  Col,
  Statistic,
  Card,
  Divider,
  Spin,
  Tag,
  Select,
  Option,
} from "antd";
import CurrencyFlag from "react-currency-flags";
import { currencyList } from "../../src/dummyData";
import { Link } from "react-router-dom";
import { useGetCryptosQuery } from "../services/cryptoAPI";
import { Cryptocurrencies, News, Statitics, Carosal } from "../componets";
import { CurrencyContext } from "../services/currencyContext.js";
const { Title } = Typography;

const Homepage = () => {
  const { currencyState } = useContext(CurrencyContext);

  const [currency, setCurrency] = currencyState;

  const { data, isFetching } = useGetCryptosQuery(10);

  const { Option } = Select;

  console.log(data);

  const globalStatus = data?.data?.stats;

  if (isFetching)
    return (
      <div className="spin">
        <Spin size="large" />
      </div>
    );

  return (
    <>
      <div className="homepageWrapper">
        <div
          className="globalStats"
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Title
            level={4}
            type="secondary"
            style={{
              textDecoration: "none",
              fontSize: "18px",
              fontWeight: "normal",
            }}
          >
            <Tag color="cyan"> Global Crypto Stats </Tag>
          </Title>

          <div className="currecySelector" style={{ alignSelf: "flex-end" }}>
            <Select
              width="100%"
              showSearch
              placeholder="Select Currency"
              optionFilterProp="children"
              onChange={(value) => setCurrency(value)}
              size="large"
              // onSearch={onSearch}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              listItemHeight={10}
              listHeight={250}
            >
              {currencyList.map((currency) => {
                return (
                  <Option value={currency}>
                    {" "}
                    <CurrencyFlag
                      currency={currency.toUpperCase()}
                      size="sm"
                    />{" "}
                    {currency}
                  </Option>
                );
              })}
            </Select>
          </div>

          <div className="status-container" style={{ margin: "20px auto" }}>
            <Row gutter={72} span={24}>
              <Col span={4} gutter={3}>
                <Card gutter={3} hoverable style={{ borderRadius: "10px" }}>
                  <Statistic
                    title="Total CryptoCurrencies"
                    value={globalStatus.total}
                    valueStyle={{ color: "#3A3845" }}
                  />
                </Card>
              </Col>

              <Col span={4}>
                <Card hoverable style={{ borderRadius: "10px" }}>
                  <Statistic
                    title="Total Exchanges"
                    value={millify(globalStatus.totalExchanges)}
                    valueStyle={{ color: "#3A3845" }}
                  />
                </Card>
              </Col>
              <Col span={4}>
                <Card hoverable style={{ borderRadius: "10px" }}>
                  <Statistic
                    title="Total Market Cap"
                    value={millify(globalStatus.totalMarketCap)}
                    valueStyle={{ color: "#3A3845" }}
                  />
                </Card>
              </Col>
              <Col span={4}>
                <Card hoverabl style={{ borderRadius: "10px" }} e>
                  <Statistic
                    title="Total 24h Volume"
                    value={millify(globalStatus.total24hVolume)}
                    valueStyle={{ color: "#3A3845" }}
                  />
                </Card>
              </Col>
              <Col span={4}>
                <Card hoverable style={{ borderRadius: "10px" }}>
                  <Statistic
                    title="Total Markets"
                    value={millify(globalStatus.totalMarkets)}
                    valueStyle={{ color: "#3A3845" }}
                  />
                </Card>
              </Col>
              <Col span={4}>
                <Card hoverable style={{ borderRadius: "10px" }}>
                  <Statistic
                    title="Total Markets"
                    value={millify(globalStatus.totalMarkets)}
                    valueStyle={{ color: "#3A3845" }}
                  />
                </Card>
              </Col>
            </Row>
          </div>

          <Divider />
          <div style={{ width: "1500px", height: "200px" }}>
            <span
              style={{
                fontSize: "18px",
                maginBottom: "70px",
                color: "#92A9BD",
              }}
            >
              <Tag color="cyan"> Trending Now </Tag>
            </span>
            <Carosal />
          </div>
        </div>

        <Statitics currencyName={currency} />

        <Divider />
        <div className="home-heading-container">
          <Title level={2} className="home-title">
            Latest Crypto News
          </Title>
          <Title level={4} className="Show-more" style={{ fontSize: "18px" }}>
            <Link to="/news">Show more</Link>
          </Title>
        </div>
        <News simplified />
      </div>
    </>
  );
};

export default Homepage;
